import { ReactElement } from 'react';
import { EIconSize } from 'utils/constants/app/ui';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const FavoriteSkeletonHeader = ({
  hideFirstSeperator = true
}: {
  hideFirstSeperator?: boolean;
}): ReactElement => {
  return (
    <div className="favorite__matchesSkeletonHeader">
      {hideFirstSeperator && (
        <div className="favorite__separatorHeader">
          <div className="titleWithCount">
            <Skeleton
              title={{ style: { width: 70, margin: 0, height: 15 } }}
              paragraph={false}
              active
            />
            <Skeleton
              title={{ style: { width: 15, margin: 0, height: 15 } }}
              paragraph={false}
              active
            />
          </div>

          <Skeleton
            title={{ style: { width: 12, margin: 0, height: 12 } }}
            paragraph={false}
            active
          />
        </div>
      )}
      <div className="favorite__sportHeader">
        <Skeleton.Avatar size={EIconSize._24} style={{ margin: 0 }} />
        <Skeleton
          title={{ style: { width: 100, margin: 0, height: 15 } }}
          paragraph={false}
          active
        />
      </div>
      <div className="favorite__separatorHeader">
        <div className="titleWithCount">
          <Skeleton.Avatar size={EIconSize._24} style={{ margin: 0 }} />

          <Skeleton
            title={{ style: { width: 150, margin: 0, height: 15 } }}
            paragraph={false}
            active
          />
        </div>
        <Skeleton
          title={{ style: { width: 12, margin: 0, height: 12 } }}
          paragraph={false}
          active
        />
      </div>
    </div>
  );
};
